import React, { useContext } from "react";
import "./PageSix.scss";
import { BuildingsContext } from "../../../bContext";

function PageSix() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );
  return (
    <>
    <div className="pageSix">
      <div className="speech-bubble4">
      {switchToEnglish === false ? 
        <p className="first">
          Podczas wirtualnej wycieczki, będzie nam towarzyszył przewodnik, który zapozna nas z obiektami oraz z zasadami działania oczyszczalni.
        </p>
        :
        <p className="first">
        During the virtual tour, we will be accompanied by a guide who will familiarize us with the facilities and the principles of operation of the treatment plant.
      </p>
}
        <div className="inner-triangle-right4"></div>
      </div>
      <div className="menu-pg4"></div>

      <div>
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </div>      
    </>
  );
}

export default PageSix;
